export default __webpack_public_path__ + "static/media/moi.dd3884cd.jpg";